import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import { LatLngExpression } from "leaflet";

import "./customMapView.css";
import { EnrollmentCustomMapView } from "../../../@types/components/enrollmentMapSection.types";

const CustomMapView: React.FC<EnrollmentCustomMapView> = ({ markers, mapType }): JSX.Element => {
	const coord = [32.7767, -96.797];
	return (
		<MapContainer center={coord as any} zoom={6} scrollWheelZoom={true}>
			<TileLayer
				attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
				url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
			/>

			{markers.map(({ positionProps, nameProps }, index) => {
				if (positionProps[0] && positionProps[1]) {
					return (
						<Marker key={index} position={positionProps as LatLngExpression}>
							{mapType === "ZIP WISE" ? (
								<Popup>
									<strong>Member Count : </strong>
									<span>{nameProps}</span>
								</Popup>
							) : mapType === "MEMBER WISE" ? (
								<Popup>
									<strong>Member Name : </strong>
									<span>{nameProps}</span>
								</Popup>
							) : (
								<></>
							)}
						</Marker>
					);
				} else {
					// console.log(positionProps);
				}
			})}
		</MapContainer>
	);
};

export default CustomMapView;
